import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useReducer, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getSearchQuerySuggestions } from './searchModule';
import createSearchSuggestionsReducer, { initialState, ActionTypes } from './createSearchSuggestionsReducer';
export default function useSearchSuggestions(_ref) {
  var inputQuery = _ref.query;
  var reduxDispatch = useDispatch();
  var query = (inputQuery || '').trim();

  var _useReducer = useReducer(createSearchSuggestionsReducer({
    query
  }), initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(() => {
    if (!query) {
      dispatch({
        type: ActionTypes.RESET,
        query
      });
    }
  }, [query]);
  useEffect(() => {
    if (query) {
      var getSuggestions = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* () {
          dispatch({
            type: ActionTypes.LOAD_SUGGESTIONS_REQUEST,
            query
          });

          try {
            var response = yield reduxDispatch(getSearchQuerySuggestions({
              query
            }));
            dispatch({
              type: ActionTypes.LOAD_SUGGESTIONS_SUCCESS,
              query,
              payload: response.payload
            });
          } catch (err) {
            dispatch({
              type: ActionTypes.LOAD_SUGGESTIONS_FAILURE,
              query,
              error: err
            });
          }
        });

        return function getSuggestions() {
          return _ref2.apply(this, arguments);
        };
      }();

      getSuggestions();
    }
  }, [query, reduxDispatch]);
  return useMemo(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      query,
      isUpToDate: state.suggestions.query === query && !state.isLoading
    });
  }, [query, state]);
}